import React, { useEffect, useState } from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import { WarningModal } from 'components/modals';
import Loader from 'ui/Loader/Loader';
import NavigationTitle, { LayoutType } from 'ui/NavigationTitle/NavigationTitle';
import Tabs from 'ui/Tabs/Tabs';
import MobileSubtitle from 'ui/MobileSubtitle/MobileSubtitle';
import { SubtabsType } from './RecallMobileMoney.model';
import RecallSingleMobileMoney from './subtabs/SingleMobileMoney/SingleMM';
import RecallBulkMobileMoney from './subtabs/BulkMobileMoney/RecallBulkMM';

const subTabsOptions = [{ label: 'Mobile Money Transfer' }, { label: 'Mobile Money Bulk Transfer' }];

const RecallMobileMoney = () => {
  const [activeSubTab, setActiveSubTab] = useState<SubtabsType>(0);
  const [nextTab, setNextTab] = useState<SubtabsType>(0);
  const [loadingData, setLoadingData] = useState(false);

  const [isFormDirty, setFormDirty] = useState(false);
  const [showWarning, setShowWarning] = useState(false);

  const downMdScreen = useMediaQuery(useTheme().breakpoints.down('sm'));

  const location = useLocation<{ subTab: SubtabsType }>();

  useEffect(() => {
    if (downMdScreen) {
      setActiveSubTab(false);
    } else {
      setActiveSubTab(nextTab);
    }
    if (location.state) {
      setActiveSubTab(location.state.subTab);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downMdScreen, location.state]);

  const handleOnChangeTab = (_event: React.ChangeEvent<unknown>, tabIndex: SubtabsType) => {
    setNextTab(tabIndex);

    if (isFormDirty) {
      setShowWarning(true);
      setLoadingData(false);
    } else {
      setActiveSubTab(tabIndex);
    }
  };

  const handleClickBack = () => {
    if (isFormDirty) {
      setShowWarning(true);
    } else {
      setActiveSubTab(false);
    }
  };

  const onLeavePage = () => {
    setShowWarning(false);
    setFormDirty(false);
    if (downMdScreen) {
      setActiveSubTab(false);
    } else {
      setActiveSubTab(nextTab);
    }
  };

  const closeWarning = () => setShowWarning(false);

  return (
    <>
      <NavigationTitle
        to="/myRequests"
        layoutType={LayoutType.dashboard}
        onClick={handleClickBack}
        noArrow={activeSubTab === false}
      >
        {activeSubTab === false || !downMdScreen ? '' : subTabsOptions[activeSubTab].label}
      </NavigationTitle>
      {downMdScreen && activeSubTab === false && <MobileSubtitle>Select category</MobileSubtitle>}
      <Tabs value={activeSubTab} options={subTabsOptions} onChange={handleOnChangeTab} theme="secondary" />
      {loadingData ? <Loader /> : null}
      {!loadingData && activeSubTab === 0 && <RecallSingleMobileMoney />}
      {!loadingData && activeSubTab === 1 && <RecallBulkMobileMoney />}
      <WarningModal open={showWarning} submitName="Leave Page" onSubmit={onLeavePage} onClose={closeWarning}>
        Entered data will be lost. Are you sure you want to leave page?
      </WarningModal>
    </>
  );
};

export default observer(RecallMobileMoney);
